export const COLOR_TRAFFIC_LIGHT_NEUTRAL =
  '--prism-color-chart-accent-primary-figure-default';
export const COLOR_TEXT_DEFAULT = '--prism-color-text-neutral-default';
export const COLOR_TEXT_SUBDUED = '--prism-color-text-neutral-subdued';
export const COLOR_TEXT_SUCCESS = '--prism-color-text-success-default';
export const COLOR_TEXT_CRITICAL = '--prism-color-text-critical-default';
export const COLOR_TRAFFIC_LIGHT_NEGATIVE =
  '--prism-color-chart-status-figure-critical-normal';
export const COLOR_TRAFFIC_LIGHT_POSITIVE =
  '--prism-color-chart-status-figure-success-normal';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getCssVariableValue(variable: string) {
  return getComputedStyle(document.documentElement).getPropertyValue(variable);
}
